import React from "react"

import {
  AWSIcon,
  DockerIcon,
  ExpressIcon,
  GitHubIcon,
  GraphQLIcon,
  JavaScriptIcon,
  JestIcon,
  MongoDBIcon,
  NestIcon,
  NextIcon,
  NodeIcon,
  PostgreSQLIcon,
  ReactIcon,
  TypescriptIcon,
} from "../assets/icons"

export const frontendTechs = [
  {
    id: 1,
    icon: <ReactIcon />,
    title: "React",
  },
  {
    id: 2,
    icon: <NextIcon />,
    title: "Next.js",
  },
]

export const languages = [
  {
    id: 1,
    icon: <JavaScriptIcon />,
    title: "JavaScript",
  },
  {
    id: 2,
    icon: <TypescriptIcon />,
    title: "TypeScript",
  },
  {
    id: 3,
    icon: <GraphQLIcon />,
    title: "GraphQL",
  },
]

export const backendTechs = [
  {
    id: 1,
    icon: <NodeIcon />,
    title: "NodeJS",
  },
  {
    id: 2,
    icon: <ExpressIcon />,
    title: "Express",
  },
  {
    id: 3,
    icon: <NestIcon />,
    title: "NestJS",
  },
]

export const databaseTechs = [
  {
    id: 1,
    icon: <PostgreSQLIcon />,
    title: "PostgreSQL",
  },
  {
    id: 2,
    icon: <MongoDBIcon />,
    title: "MongoDB",
  },
]

export const otherTechs = [
  {
    id: 1,
    icon: <AWSIcon />,
    title: "AWS",
  },
  {
    id: 2,
    icon: <DockerIcon />,
    title: "Docker",
  },
  {
    id: 3,
    icon: <GitHubIcon />,
    title: "GitHub Actions",
  },
  {
    id: 4,
    icon: <JestIcon />,
    title: "Jest",
  },
]
